import { useMemo } from "react";
import { useDynamicOffers } from "@apac/feature-flags";
import type { Promotion } from "@b2bportal/hsbc-promotions-api";
import type { AccountPromotions, HsbcPromotedDestinations } from "@hsbc/portal";
import { FeatureFlagNames } from "@hsbc/utilities";

type PremierDestinationPromotionMap<T> = Record<
  "hotels" | "flights" | "cars",
  T
>;

export interface UsePremierDestinationPromotionReturn {
  enabledPromotions: PremierDestinationPromotionMap<boolean>;
  activePremierDestinations: PremierDestinationPromotionMap<
    Array<HsbcPromotedDestinations>
  >;
  promotions: PremierDestinationPromotionMap<Array<Promotion>>;
  isPromotionEnabled: (name: AccountPromotions) => boolean;
}

export const usePremierDestinationPromotion =
  (): UsePremierDestinationPromotionReturn => {
    const { sortedOffers: offers } = useDynamicOffers<HsbcPromotedDestinations>(
      {
        flagPrefix: FeatureFlagNames.PROMOTED_DESTINATIONS_PREFIX,
      }
    );

    return useMemo(
      () => ({
        activePremierDestinations: {
          cars: offers,
          flights: offers,
          hotels: offers,
        },
        enabledPromotions: {
          cars: offers.length > 0,
          flights: offers.length > 0,
          hotels: offers.length > 0,
        },
        promotions: {
          cars: [],
          flights: [],
          hotels: [],
        },
        // premier destination not linked to account promotion
        isPromotionEnabled: () => true,
      }),
      [offers]
    );
  };
